import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Rocket, CheckCircle2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Loader } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";

export default function Fund() {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { user, refresh } = useAuth();
  const [packages, setPackages] = useState(null);
  const [picked, setPicked] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api("/promo-packages").then(setPackages).catch(() => setPackages([])); }, []);

  const fund = async () => {
    if (!picked) return toast.error("اختر باقة");
    setBusy(true);
    try {
      await api(`/products/${productId}/fund`, { method: "POST", body: JSON.stringify({ package_id: picked.package_id }) });
      toast.success("تم تمويل المنتج بنجاح 🚀");
      refresh();
      navigate("/my-promotions");
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  if (!packages) return <Loader />;
  const bal = Number(user?.wallet_balance || 0);

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="تمويل المنتج" subtitle={`رصيد المحفظة: ${bal.toFixed(2)} د.ل`} />
      <div className="space-y-3">
        {packages.map((p) => {
          const sel = picked?.package_id === p.package_id;
          return (
            <button key={p.package_id} data-testid={`pkg-${p.package_id}`} onClick={() => setPicked(p)} className={`w-full flex items-center gap-3 p-4 rounded-2xl border-2 text-start ${sel ? "border-[#FF3D5A] bg-[#FFE5EA]" : "border-[#E8EAF2] bg-white"}`}>
              <div className="w-12 h-12 rounded-2xl bg-[#FF8A3C] text-white flex items-center justify-center"><Rocket size={22} /></div>
              <div className="flex-1">
                <p className="font-black text-[#161629]">{p.name || `باقة ${p.tier}`}</p>
                <p className="text-sm text-[#6B7280]">{p.days} يوم{p.target_impressions ? ` • ${p.target_impressions} ظهور` : ""}</p>
              </div>
              <div className="text-end">
                <p className="font-black text-[#FF3D5A]">{Number(p.price).toFixed(2)} د.ل</p>
                {sel && <CheckCircle2 size={18} className="text-[#FF3D5A] inline-block mt-1" />}
              </div>
            </button>
          );
        })}
      </div>
      <button data-testid="fund-submit" disabled={busy} onClick={fund} className="w-full h-14 rounded-2xl bg-[#FF3D5A] text-white font-black mt-6 disabled:opacity-60">{busy ? "..." : "تمويل من المحفظة"}</button>
    </div>
  );
}
